<template>
  <div class="page-bg page">
    <SubHeader :title="headerTitle"></SubHeader>
    <div class="main">
      <div class="page-content">
        <div class="news-content">
          <div class="news-detail">
            <div v-html="detail.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import SubHeader from "../../../components/sub_header";
import { mapActions, mapState } from "vuex";

import { Toast } from "vant";
Vue.use(Toast);

export default {
  name: "goods",
  data() {
    return {
      id: this.$route.params.id ? this.$route.params.id : "",
      headerTitle: "",
    };
  },

  components: {
    SubHeader,
  },

  created() {
    let toastLoading = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "正在加载...",
    });
    this.getDetails({
      id: this.id,
      success: (res) => {
        toastLoading.clear();

        document.title = this.detail.title;
        this.headerTitle = this.detail.title;
      },
    });
  },
  methods: {
    ...mapActions({
      getDetails: "index/getDetails",
    }),
  },
  computed: {
    ...mapState({
      detail: (state) => state.index.detail,
    }),
  },
  mounted() {},
  beforeDestroy() {},

  activated() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  padding-bottom: 1.2rem;
  box-sizing: border-box;
  height: 100vh;
}

.main {
  width: 100%;
  box-sizing: border-box;
  height: calc(100vh - 1.45rem);
  position: relative;
}

.page-content {
  position: relative;
  overflow-y: auto;
  height: 100%;
}

.news-content {
  padding: 0 0.3rem 0.5rem;
  box-sizing: border-box;

  .news-title {
    color: #000;
    font-weight: 600;
    margin-bottom: 0.1rem;
    font-size: 0.28rem;
    line-height: 1.8;
  }

  .news-detail {
    font-size: 0.26rem;
    color: #666;
    line-height: 1.6;
    img {
      max-width: 100%;
      height: auto;
    }
  }
}
</style>